/* ============================================================
   OS Coaching-Toolbox  ·  Vanilla JS, keine Libraries, kein Backend.
   Alle Berechnungen laufen clientseitig. Keine personenbezogenen
   Daten verlassen den Browser.

   Aufbau der Datei:
     0) Normtabellen & Konstanten  (Datenobjekte, in Phase 2/3 gefuellt)
     1) Kleine Helfer              (Parsing, Runden, DOM)
     2) UI-Grundgeruest            (Accordion, Tabs/Swipe)
     3) Rechner                    (Phase 2)
     4) Selbsttests                (Phase 3)
     5) Persistenz/Timer/Metronom  (Phase 4)
     6) Init pro Section           (Lazy per IntersectionObserver)
   ============================================================ */
(function () {
  'use strict';

  /* ==========================================================
     0) NORMTABELLEN & KONSTANTEN
     Bewusst als schlichte, gut kommentierte Datenobjekte am
     Dateianfang, damit Werte spaeter leicht anpassbar sind.
     (Werden in Phase 2 & 3 befuellt.)
     ========================================================== */
  // --- Rechner: BMI-Kategorien (WHO). Treffer, wenn bmi < upTo. ---
  var BMI_CATS = [
    { upTo: 18.5,     label: 'Untergewicht',       level: 'yellow' },
    { upTo: 25,       label: 'Normalgewicht',      level: 'green' },
    { upTo: 30,       label: 'Übergewicht',        level: 'yellow' },
    { upTo: 35,       label: 'Adipositas Grad I',  level: 'orange' },
    { upTo: 40,       label: 'Adipositas Grad II', level: 'red' },
    { upTo: Infinity, label: 'Adipositas Grad III', level: 'red' }
  ];
  // Farbsegmente fuer den BMI-Skalenbalken (15–40)
  var BMI_SCALE = [
    { upTo: 18.5, level: 'yellow' },
    { upTo: 25,   level: 'green' },
    { upTo: 30,   level: 'yellow' },
    { upTo: 35,   level: 'orange' },
    { upTo: 40,   level: 'red' }
  ];
  // Farb-Legende unter dem BMI-Balken (was bedeuten die Zonen)
  var BMI_LEGEND = [
    { level: 'green',  label: 'Normalgewicht' },
    { level: 'yellow', label: 'Unter-/Übergewicht' },
    { level: 'orange', label: 'Adipositas I' },
    { level: 'red',    label: 'Adipositas II–III' }
  ];

  // --- Rechner: WHR (Taille/Huefte), getrennt nach Geschlecht. Treffer, wenn whr < upTo. ---
  var WHR = {
    m: [
      { upTo: 0.90,     label: 'niedrig', level: 'green' },
      { upTo: 1.00,     label: 'erhöht',  level: 'yellow' },
      { upTo: Infinity, label: 'hoch',    level: 'red' }
    ],
    w: [
      { upTo: 0.80,     label: 'niedrig', level: 'green' },
      { upTo: 0.85,     label: 'erhöht',  level: 'yellow' },
      { upTo: Infinity, label: 'hoch',    level: 'red' }
    ]
  };

  // --- Rechner: Aktivitaetsfaktoren (PAL) — nur zur Referenz; Werte stehen als <option> im HTML ---
  // 1.2 sitzend · 1.375 leicht · 1.55 moderat · 1.725 sehr aktiv · 1.9 koerperliche Arbeit

  // --- Rechner: Herzfrequenz-Zonen (Anteil der Herzfrequenzreserve, Karvonen) ---
  var HR_ZONES = [
    { name: 'Regeneration',       lo: 0.50, hi: 0.60, use: 'lockere Bewegung, aktive Erholung' },
    { name: 'Grundlagenausdauer', lo: 0.60, hi: 0.70, use: 'Fettstoffwechsel, Basistraining — hier liegt der Großteil' },
    { name: 'Aerobes Training',   lo: 0.70, hi: 0.80, use: 'Verbesserung der Ausdauerleistung' },
    { name: 'Intensiv',           lo: 0.80, hi: 0.90, use: 'Intervalle, nur für Trainierte' }
  ];

  /* ---- Selbsttests: gemeinsame Bewertungsstufen (score fuer Durchschnitt) ---- */
  var RATE = {
    sehrgut: { label: 'sehr gut',         level: 'green',  score: 4 },
    gut:     { label: 'gut',              level: 'green',  score: 3 },
    durch:   { label: 'durchschnittlich', level: 'yellow', score: 2 },
    ausbau:  { label: 'ausbaufähig',      level: 'orange', score: 1 },
    schwach: { label: 'schwach',          level: 'red',    score: 0 }
  };

  // Vorab-Check (PAR-Q): 7 Fragen als Text (Auswertung siehe Engine)
  var PARQ = [
    'Hat dir jemals ein Arzt gesagt, dass du eine Herzerkrankung hast oder dich nur unter ärztlicher Aufsicht belasten sollst?',
    'Hast du Schmerzen in der Brust bei körperlicher Anstrengung?',
    'Hattest du im letzten Monat Brustschmerzen in Ruhe?',
    'Verlierst du das Gleichgewicht durch Schwindel, oder hast du schon einmal das Bewusstsein verloren?',
    'Hast du Knochen- oder Gelenkprobleme, die sich durch Belastung verschlimmern könnten?',
    'Nimmst du aktuell verschreibungspflichtige Medikamente für Blutdruck oder Herz?',
    'Kennst du einen anderen Grund, warum du dich nicht körperlich belasten solltest?'
  ];

  // Cooper-Test (Meter in 12 Min.). Untergrenzen: sg=darueber sehr gut, gu/du/au = Mindestwert.
  // Altersband per maxAge; Auswertung: d>sg? sehrgut : d>=gu? gut : d>=du? durch : d>=au? ausbau : schwach
  var COOPER = [
    { maxAge: 29, m: { sg: 2800, gu: 2400, du: 2200, au: 1600 }, w: { sg: 2700, gu: 2200, du: 1800, au: 1500 } },
    { maxAge: 39, m: { sg: 2700, gu: 2300, du: 1900, au: 1500 }, w: { sg: 2500, gu: 2000, du: 1700, au: 1400 } },
    { maxAge: 49, m: { sg: 2500, gu: 2100, du: 1700, au: 1400 }, w: { sg: 2300, gu: 1900, du: 1500, au: 1200 } },
    { maxAge: 200, m: { sg: 2400, gu: 2000, du: 1600, au: 1300 }, w: { sg: 2200, gu: 1700, du: 1400, au: 1100 } }
  ];

  // 3-Minuten-Step-Test (Erholungspuls, niedriger = besser). a/b/c = Obergrenzen der Stufen.
  var STEP = {
    m: { a: 85, b: 100, c: 117 }, // <a sehr gut, <=b gut, <=c durch, sonst ausbau
    w: { a: 93, b: 110, c: 125 }
  };

  // Ruhepuls-Bonus (morgens)
  function rateRuhepuls(p) {
    if (p < 60) return { label: 'sehr gut', level: 'green' };
    if (p <= 70) return { label: 'gut', level: 'green' };
    if (p <= 80) return { label: 'durchschnittlich', level: 'yellow' };
    return { label: 'erhöht – beobachten', level: 'orange' };
  }

  // Kniebeugen 60 s (Basiswerte; ab 40 J. je Jahrzehnt -5 Wdh.)
  var SQUAT = {
    m: { sg: 49, gu: 40, du: 30 }, // r>sg sehrgut, r>=gu gut, r>=du durch, sonst ausbau
    w: { sg: 44, gu: 35, du: 25 }
  };

  // Liegestuetze max. am Stück — nach Variante (standard/knie) und Altersband.
  // r>=sg sehrgut, r>=gu gut, r>=du durch, sonst ausbau
  var PUSHUP = {
    standard: [
      { maxAge: 29, sg: 36, gu: 29, du: 22 },
      { maxAge: 39, sg: 30, gu: 22, du: 17 },
      { maxAge: 49, sg: 25, gu: 17, du: 13 },
      { maxAge: 59, sg: 21, gu: 13, du: 10 },
      { maxAge: 200, sg: 18, gu: 11, du: 8 }
    ],
    knie: [
      { maxAge: 29, sg: 30, gu: 21, du: 15 },
      { maxAge: 39, sg: 27, gu: 20, du: 13 },
      { maxAge: 49, sg: 24, gu: 15, du: 11 },
      { maxAge: 59, sg: 21, gu: 11, du: 7 },
      { maxAge: 200, sg: 17, gu: 12, du: 5 }
    ]
  };

  // Plank (Sekunden): s>120 sehrgut, s>=60 gut, s>=30 durch, sonst ausbau
  var PLANK = { sg: 120, gu: 60, du: 30 };

  // Wandsitz (Sekunden) nach Geschlecht: s>sg sehrgut, s>=gu gut, s>=du durch, sonst ausbau
  var WALLSIT = {
    m: { sg: 100, gu: 75, du: 50 },
    w: { sg: 60, gu: 45, du: 35 }
  };

  // Sit-to-Stand 30 s (Alternative 60+/Einsteiger): "altersgerecht ab" Wert je Alter/Geschlecht
  var SITTOSTAND = [
    { maxAge: 64, m: 14, w: 12 },
    { maxAge: 69, m: 12, w: 11 },
    { maxAge: 74, m: 12, w: 10 },
    { maxAge: 79, m: 11, w: 10 },
    { maxAge: 200, m: 10, w: 9 }
  ];

  // Einbeinstand — Referenz "gut ab" (Sekunden) fuer Augen offen / geschlossen
  var BALANCE = [
    { maxAge: 39, open: 43, closed: 9 },
    { maxAge: 49, open: 40, closed: 7 },
    { maxAge: 59, open: 36, closed: 5 },
    { maxAge: 69, open: 25, closed: 3 },
    { maxAge: 200, open: 14, closed: 2 }
  ];

  // Kleiner Helfer: passendes Altersband aus einer maxAge-Liste holen
  function bandFor(list, age) {
    for (var i = 0; i < list.length; i++) { if (age <= list[i].maxAge) return list[i]; }
    return list[list.length - 1];
  }

  /* ==========================================================
     1) KLEINE HELFER
     ========================================================== */

  // Komma UND Punkt als Dezimaltrenner akzeptieren; leere/ungueltige -> NaN
  function parseNum(value) {
    if (value === null || value === undefined) return NaN;
    var s = String(value).trim().replace(',', '.');
    if (s === '') return NaN;
    var n = Number(s);
    return isFinite(n) ? n : NaN;
  }

  // Auf n Dezimalen runden (kaufmaennisch, gibt Number zurueck)
  function round(value, decimals) {
    var f = Math.pow(10, decimals || 0);
    return Math.round(value * f) / f;
  }

  // Auf Vielfaches (z. B. 10 kcal) runden
  function roundToStep(value, step) {
    return Math.round(value / step) * step;
  }

  // Deutsche Zahlausgabe (Punkt -> Komma)
  function fmt(value, decimals) {
    if (!isFinite(value)) return '–';
    var n = (decimals === undefined) ? value : round(value, decimals);
    return String(n).replace('.', ',');
  }

  // Deutsche Zahlausgabe mit fester Dezimalstellenzahl (z. B. BMI 17,0 · WHR 1,10)
  function fmtFixed(value, decimals) {
    if (!isFinite(value)) return '–';
    return value.toFixed(decimals).replace('.', ',');
  }

  // Wert innerhalb [min,max]? (inklusive Grenzen)
  function inRange(n, min, max) {
    return isFinite(n) && n >= min && n <= max;
  }

  // DOM-Helfer, immer relativ zur Section-Root
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ==========================================================
     2) UI-GRUNDGERUEST
     ========================================================== */

  // --- 2a) Accordion: nur eine Gruppe gleichzeitig offen -----
  function initAccordion(root) {
    var heads = qsa(root, '.os-ctb-group-head');

    function setOpen(head, open) {
      var body = document.getElementById(head.getAttribute('aria-controls'));
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.hidden = !open;
    }

    heads.forEach(function (head) {
      // initial geschlossen
      setOpen(head, false);
      head.addEventListener('click', function () {
        var isOpen = head.getAttribute('aria-expanded') === 'true';
        // erst alle schliessen ...
        heads.forEach(function (h) { setOpen(h, false); });
        // ... dann ggf. die geklickte oeffnen (Toggle)
        if (!isOpen) setOpen(head, true);
      });
    });
  }

  // --- 2b) Tab-/Swipe-Navigation (role=tablist) --------------
  // Erwartet: Container .os-ctb-tabgroup mit
  //   .os-ctb-tabs[role=tablist] > .os-ctb-tab[role=tab][aria-controls]
  //   Panels .os-ctb-panel[role=tabpanel]
  //   optionale Pfeile [data-tabs-prev] / [data-tabs-next]
  function initTabGroup(group) {
    var tablist = qs(group, '[role="tablist"]');
    if (!tablist) return;
    var tabs = qsa(tablist, '[role="tab"]');
    var prevBtn = qs(group, '[data-tabs-prev]');
    var nextBtn = qs(group, '[data-tabs-next]');

    function panelOf(tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    }

    function select(index, focus) {
      index = Math.max(0, Math.min(tabs.length - 1, index));
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        var panel = panelOf(tab);
        if (panel) panel.hidden = !active;
      });
      var activeTab = tabs[index];
      if (activeTab) {
        // aktiven Tab in die sichtbare Scrollregion holen (mobil swipebar)
        activeTab.scrollIntoView({ block: 'nearest', inline: 'center' });
        if (focus) activeTab.focus();
      }
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === tabs.length - 1;
      group._activeIndex = index;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var idx = group._activeIndex || 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); select(idx + 1, true); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); select(idx - 1, true); }
        else if (e.key === 'Home') { e.preventDefault(); select(0, true); }
        else if (e.key === 'End') { e.preventDefault(); select(tabs.length - 1, true); }
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { select((group._activeIndex || 0) - 1, false); });
    if (nextBtn) nextBtn.addEventListener('click', function () { select((group._activeIndex || 0) + 1, false); });

    select(0, false);
  }

  /* ==========================================================
     3) RECHNER  — Phase 2 (folgt)
     ========================================================== */
  // HTML-Escape fuer eingesetzte Textbausteine
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Ergebnis-Badge (Ampel). level = green|yellow|orange|red
  function badge(level, text) {
    return '<span class="os-ctb-badge os-ctb-badge--' + level + '">' + esc(text) + '</span>';
  }

  // Dezenter Coaching-Verweis unter jedem Ergebnis (Spec)
  function coachHint() {
    return '<p class="os-ctb-result-hint">Im Coaching leiten wir daraus deine Trainingsbereiche ab.</p>';
  }

  // Ein Feld lesen + validieren. Setzt rote Umrandung + Hinweis bei Werten ausserhalb der Grenzen.
  function readField(calc, name, min, max, integer) {
    var el = qs(calc, '[data-in="' + name + '"]');
    var errEl = qs(calc, '[data-err="' + name + '"]');
    var raw = el ? el.value : '';
    var empty = String(raw).trim() === '';
    var n = parseNum(raw);
    if (integer && isFinite(n)) n = Math.round(n);
    var valid = inRange(n, min, max);
    if (el) el.classList.toggle('is-error', !empty && !valid);
    if (errEl) {
      if (!empty && !valid) {
        errEl.hidden = false;
        errEl.textContent = 'Wert zwischen ' + fmt(min) + ' und ' + fmt(max) + ' eingeben.';
      } else {
        errEl.hidden = true;
        errEl.textContent = '';
      }
    }
    return { value: valid ? n : NaN, empty: empty, valid: valid };
  }

  function readSex(calc) {
    var seg = qs(calc, '[data-in="sex"]');
    return seg ? (seg.getAttribute('data-value') || 'm') : 'm';
  }

  // Alle Felder ok? (nicht leer UND gueltig)
  function allReady(fields) {
    return fields.every(function (f) { return !f.empty && f.valid; });
  }

  // rich (optional): strukturierte Ergebnisdaten fuer den Export
  //   { items:[{name,value,unit,rating:{label,level},ref}], overall:{label,level} }
  function showResult(calc, html, rich) {
    var box = qs(calc, '[data-result]');
    if (!box) return;
    box.innerHTML = html;
    box.hidden = false;
    box.__ctb = rich || null;
  }
  function hideResult(calc) {
    var box = qs(calc, '[data-result]');
    if (!box) return;
    box.hidden = true;
    box.innerHTML = '';
    box.__ctb = null;
  }

  // Skalenbalken mit farbigen Zonen + Overlay-Marker (+ optionale Farb-Legende)
  function scaleHtml(min, max, value, segments, legend) {
    var span = max - min;
    var bars = '';
    var prev = min;
    segments.forEach(function (s) {
      var to = Math.min(s.upTo, max);
      var w = Math.max(0, (to - prev) / span * 100);
      bars += '<div class="os-ctb-scale-seg" style="width:' + w + '%;background:var(--ctb-' + s.level + ')"></div>';
      prev = to;
    });
    var pos = Math.max(0, Math.min(100, (value - min) / span * 100));
    var leg = '';
    if (legend) {
      leg = '<div class="os-ctb-scale-legend">' + legend.map(function (it) {
        return '<span class="os-ctb-lg"><i style="background:var(--ctb-' + it.level + ')"></i>' + esc(it.label) + '</span>';
      }).join('') + '</div>';
    }
    return '<div class="os-ctb-scale"><div class="os-ctb-scale-track">' + bars + '</div>' +
      '<div class="os-ctb-scale-marker" style="left:' + pos + '%"></div>' +
      '<div class="os-ctb-scale-labels"><span>' + fmt(min) + '</span><span>' + fmt(max) + '</span></div></div>' +
      leg;
  }

  /* ---- Die vier Rechner ---- */
  var CALC = {

    // Tab 1: BMI
    bmi: function (calc) {
      var h = readField(calc, 'height', 120, 220);
      var w = readField(calc, 'weight', 35, 250);
      if (!allReady([h, w])) return hideResult(calc);

      var m = h.value / 100;
      var bmi = round(w.value / (m * m), 1);
      var cat = BMI_CATS.filter(function (c) { return bmi < c.upTo; })[0];

      var texts = ['Der BMI unterscheidet nicht zwischen Muskel- und Fettmasse. Bei muskulösen Personen fällt er zu hoch aus — kombiniere ihn mit dem Taille-Rechner für ein vollständigeres Bild.'];
      if (cat.label === 'Untergewicht') {
        texts.push('Dein Wert liegt im Untergewichtsbereich. Falls du abnehmen möchtest, sprich das bitte zuerst ärztlich oder im Coaching an — hier steht Gesundheit vor Optik.');
      }

      var html = badge(cat.level, cat.label) +
        '<div class="os-ctb-result-value">' + fmtFixed(bmi, 1) + ' <span style="font-size:14px;font-weight:700;color:var(--ctb-muted-soft)">kg/m²</span></div>' +
        scaleHtml(15, 40, bmi, BMI_SCALE, BMI_LEGEND) +
        texts.map(function (t) { return '<p class="os-ctb-result-text">' + esc(t) + '</p>'; }).join('') +
        coachHint();
      showResult(calc, html);
    },

    // Tab 2: Taille & Hüfte (WHR + WHtR)
    waist: function (calc) {
      var sex = readSex(calc);
      var waist = readField(calc, 'waist', 50, 200);
      var hip = readField(calc, 'hip', 60, 200);
      var height = readField(calc, 'height', 120, 220);
      var age = readField(calc, 'age', 14, 99, true);
      if (!allReady([waist, hip, height, age])) return hideResult(calc);

      var whr = round(waist.value / hip.value, 2);
      var whtr = round(waist.value / height.value, 2);

      var whrCat = WHR[sex].filter(function (c) { return whr < c.upTo; })[0];

      // Altersabhaengiger WHtR-Grenzwert
      var G;
      if (age.value <= 40) G = 0.50;
      else if (age.value <= 50) G = round(0.50 + (age.value - 40) * 0.01, 2);
      else G = 0.60;

      var whtrCat;
      if (whtr < 0.40) whtrCat = { label: 'sehr schlank', level: 'yellow' };
      else if (whtr <= G) whtrCat = { label: 'unauffällig', level: 'green' };
      else if (whtr <= round(G + 0.1, 2)) whtrCat = { label: 'erhöht', level: 'orange' };
      else whtrCat = { label: 'deutlich erhöht', level: 'red' };

      var html = '<div class="os-ctb-subresults">' +
        '<div class="os-ctb-subresult"><div class="lbl">WHR · Taille/Hüfte</div><div class="num">' + fmtFixed(whr, 2) + '</div>' + badge(whrCat.level, whrCat.label) + '</div>' +
        '<div class="os-ctb-subresult"><div class="lbl">WHtR · Taille/Größe</div><div class="num">' + fmtFixed(whtr, 2) + '</div>' + badge(whtrCat.level, whtrCat.label) + '</div>' +
        '</div>' +
        '<p class="os-ctb-result-text"><b>WHR</b> (Waist-to-Hip Ratio) vergleicht Taille und Hüfte und zeigt, <em>wo</em> sich Fett sammelt – eher am Bauch (höheres Risiko) oder an der Hüfte. <b>WHtR</b> (Waist-to-Height Ratio) setzt die Taille ins Verhältnis zu deiner Größe und schätzt das Bauchfett-Risiko unabhängig vom Körperbau – dieser Wert gilt als der aussagekräftigere von beiden.</p>' +
        '<p class="os-ctb-result-text">Bauchfett ist stoffwechselaktiv und aussagekräftiger für das Gesundheitsrisiko als das Gewicht allein. Das Taille-zu-Größe-Verhältnis gilt als bester einfacher Marker.</p>' +
        coachHint();
      showResult(calc, html);
    },

    // Tab 3: Grund- & Leistungsumsatz (Mifflin-St Jeor)
    energy: function (calc) {
      var sex = readSex(calc);
      var age = readField(calc, 'age', 14, 99, true);
      var height = readField(calc, 'height', 120, 220);
      var weight = readField(calc, 'weight', 35, 250);
      var palEl = qs(calc, '[data-in="pal"]');
      var pal = parseNum(palEl ? palEl.value : '');
      if (!allReady([age, height, weight]) || !isFinite(pal)) return hideResult(calc);

      var rawGU = 10 * weight.value + 6.25 * height.value - 5 * age.value + (sex === 'm' ? 5 : -161);
      var gu = roundToStep(rawGU, 10);
      var tdee = roundToStep(rawGU * pal, 10);

      var html = '<span class="os-ctb-badge os-ctb-badge--green" style="background:var(--ctb-pure-black)">Dein geschätzter Tagesbedarf</span>' +
        '<div class="os-ctb-metrics">' +
        '<div class="os-ctb-metric"><div class="k">Grundumsatz</div><div class="v">' + fmt(gu) + ' <span style="font-size:13px;color:var(--ctb-muted-soft)">kcal/Tag</span></div></div>' +
        '<div class="os-ctb-metric"><div class="k">Gesamtumsatz</div><div class="v">' + fmt(tdee) + ' <span style="font-size:13px;color:var(--ctb-muted-soft)">kcal/Tag</span></div></div>' +
        '</div>' +
        '<div class="os-ctb-targets">' +
        '<div class="os-ctb-target"><span>Abnehmen</span><b>' + fmt(tdee - 500) + '–' + fmt(tdee - 300) + ' kcal</b></div>' +
        '<div class="os-ctb-target"><span>Halten</span><b>≈ ' + fmt(tdee) + ' kcal</b></div>' +
        '<div class="os-ctb-target"><span>Zunehmen / Muskelaufbau</span><b>' + fmt(tdee + 200) + '–' + fmt(tdee + 300) + ' kcal</b></div>' +
        '</div>' +
        '<p class="os-ctb-result-text">Für <b>Zunehmen bzw. Muskelaufbau</b> brauchst du einen leichten Kalorienüberschuss: Dein Körper baut neue Muskulatur nur auf, wenn du ihm etwas mehr Energie gibst, als er verbraucht. Ebenso wichtig ist genug Eiweiß – als Orientierung gelten rund 1,6–2,0 g pro kg Körpergewicht am Tag.</p>' +
        '<p class="os-ctb-result-hint">Formelwerte sind Schätzungen (± 10 %). Im Coaching kalibrieren wir sie an deiner realen Entwicklung.</p>';
      showResult(calc, html);
    },

    // Tab 4: Zielherzfrequenz (Karvonen + Tanaka-HFmax)
    hr: function (calc) {
      var age = readField(calc, 'age', 14, 99, true);
      var rest = readField(calc, 'rest', 35, 110, true);
      if (!allReady([age, rest])) return hideResult(calc);

      var hfmax = Math.round(208 - 0.7 * age.value);
      var reserve = hfmax - rest.value;

      var zonesHtml = HR_ZONES.map(function (z) {
        var lo = Math.round(rest.value + reserve * z.lo);
        var hi = Math.round(rest.value + reserve * z.hi);
        return '<div class="os-ctb-zone">' +
          '<span class="os-ctb-zone-name">' + esc(z.name) + '</span>' +
          '<span class="os-ctb-zone-bpm">' + lo + '–' + hi + ' bpm</span>' +
          '<span class="os-ctb-zone-for">' + esc(z.use) + '</span>' +
          '</div>';
      }).join('');

      var html = '<span class="os-ctb-badge os-ctb-badge--green" style="background:var(--ctb-pure-black)">HFmax ca. ' + hfmax + ' bpm</span>' +
        '<div class="os-ctb-zones">' + zonesHtml + '</div>' +
        '<p class="os-ctb-result-hint">Beta-Blocker &amp; Co. verschieben die Herzfrequenz — dann gilt diese Tabelle nicht. Sag uns im Coaching Bescheid.</p>' +
        coachHint();
      showResult(calc, html);
    }
  };

  function initCalculators(root) {
    qsa(root, '.os-ctb-calc').forEach(function (calc) {
      var type = calc.getAttribute('data-calc');
      var compute = CALC[type];
      if (!compute) return;

      function run() { compute(calc); }

      // Geschlecht-/Segment-Umschalter
      qsa(calc, '.os-ctb-seg').forEach(function (seg) {
        qsa(seg, 'button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            seg.setAttribute('data-value', btn.getAttribute('data-val'));
            qsa(seg, 'button').forEach(function (b) {
              b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
            });
            run();
          });
        });
      });

      // Eingaben live auswerten
      qsa(calc, 'input, select').forEach(function (el) {
        el.addEventListener('input', run);
        el.addEventListener('change', run);
      });
    });
  }

  /* ==========================================================
     4) SELBSTTESTS  — Phase 3 (folgt)
     ========================================================== */
  // Inline-Badge-Ergebnis in eine [data-st-result]-Box schreiben
  function inlineBox(el, html) {
    if (!el) return;
    if (html === null) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    el.innerHTML = html;
  }

  /* ---- Einzelne Test-Auswertungen ---- */

  function computeCooper(panel) {
    var sex = readSex(panel);
    var dist = readField(panel, 'dist', 400, 8000, true);
    var age = readField(panel, 'age', 10, 120, true);
    if (!allReady([dist, age])) return hideResult(panel);
    var band = bandFor(COOPER, age.value);
    var t = band[sex];
    var d = dist.value;
    var r = d > t.sg ? RATE.sehrgut : d >= t.gu ? RATE.gut : d >= t.du ? RATE.durch : d >= t.au ? RATE.ausbau : RATE.schwach;
    var vo2 = (d - 504.9) / 44.73;
    showResult(panel, badge(r.level, r.label) +
      '<div class="os-ctb-result-value">' + fmt(d) + ' m</div>' +
      '<p class="os-ctb-result-text">Geschätzte VO₂max: <b>' + fmtFixed(vo2, 1) + '</b> ml/kg/min (geschätzt).</p>' +
      coachHint(), {
      overall: r,
      items: [{ name: 'Cooper-Test (12 Min. Lauf)', value: fmt(d), unit: 'm', rating: r,
        ref: 'in deiner Altersgruppe: durchschnittlich ab ' + fmt(t.du) + ' m, gut ab ' + fmt(t.gu) + ' m, sehr gut über ' + fmt(t.sg) + ' m' },
        { name: 'Geschätzte VO₂max', value: fmtFixed(vo2, 1), unit: 'ml/kg/min', rating: null, ref: 'aus der Laufdistanz geschätzt' }]
    });
  }

  function computeStep(panel) {
    var sex = readSex(panel);
    var p = readField(panel, 'pulse', 40, 220, true);
    if (!allReady([p])) return hideResult(panel);
    var t = STEP[sex];
    var pv = p.value;
    var r = pv < t.a ? RATE.sehrgut : pv <= t.b ? RATE.gut : pv <= t.c ? RATE.durch : RATE.ausbau;
    showResult(panel, badge(r.level, r.label) +
      '<div class="os-ctb-result-value">' + fmt(pv) + ' bpm</div>' +
      coachHint(), {
      overall: r,
      items: [{ name: 'Step-Test (Erholungspuls)', value: fmt(pv), unit: 'bpm', rating: r,
        ref: 'niedriger = besser · in deiner Altersgruppe: sehr gut unter ' + fmt(t.a) + ', gut bis ' + fmt(t.b) + ', durchschnittlich bis ' + fmt(t.c) + ' bpm' }]
    });
  }

  function computeRuhepuls(bonus) {
    var p = readField(bonus, 'rest', 30, 120, true);
    if (!allReady([p])) return hideResult(bonus);
    var r = rateRuhepuls(p.value);
    showResult(bonus, badge(r.level, 'Ruhepuls: ' + r.label) +
      '<div class="os-ctb-result-value">' + fmt(p.value) + ' bpm</div>', {
      overall: { label: r.label, level: r.level },
      items: [{ name: 'Ruhepuls (morgens)', value: fmt(p.value), unit: 'bpm', rating: { label: r.label, level: r.level },
        ref: 'niedriger = besser · sehr gut unter 60, gut 60–70, durchschnittlich 71–80 bpm' }]
    });
  }

  /* ---- Die fünf Selbsttests ---- */
  var TEST = {

    // 4.1 Vorab-Check (PAR-Q)
    parq: function (test) {
      var list = qs(test, '[data-parq-list]');
      if (list && list.dataset.built !== '1') {
        PARQ.forEach(function (q, i) {
          var row = document.createElement('div');
          row.className = 'os-ctb-q';
          row.innerHTML = '<p class="os-ctb-q-text">' + (i + 1) + '. ' + esc(q) + '</p>' +
            '<div class="os-ctb-yn" data-yn data-value="" role="group" aria-label="Antwort Frage ' + (i + 1) + '">' +
            '<button type="button" data-val="ja" aria-pressed="false">Ja</button>' +
            '<button type="button" data-val="nein" aria-pressed="false">Nein</button></div>';
          list.appendChild(row);
        });
        list.dataset.built = '1';
        qsa(list, '[data-yn]').forEach(function (yn) {
          qsa(yn, 'button').forEach(function (b) {
            b.addEventListener('click', function () {
              yn.setAttribute('data-value', b.getAttribute('data-val'));
              qsa(yn, 'button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
              TEST.parq(test);
            });
          });
        });
      }
      var yns = qsa(list, '[data-yn]');
      var answered = yns.filter(function (y) { return y.getAttribute('data-value'); }).length;
      var ja = yns.filter(function (y) { return y.getAttribute('data-value') === 'ja'; }).length;
      if (ja >= 1) {
        showResult(test, badge('orange', 'Bitte zuerst ärztlich abklären') +
          '<p class="os-ctb-result-text">Bitte kläre deine Belastbarkeit zuerst ärztlich ab, bevor du die Selbsttests oder ein neues Training beginnst. Lade dazu unseren Gesundheitsfragebogen herunter – er hilft auch beim Arztgespräch.</p>' +
          '<div style="margin-top:10px"><button type="button" class="os-ctb-btn os-ctb-btn--primary" data-open-forms>Zu den Formularen</button></div>');
      } else if (answered === PARQ.length) {
        showResult(test, badge('green', 'Alles im grünen Bereich') +
          '<p class="os-ctb-result-text">Aus Sicht dieses Kurzchecks spricht nichts gegen die Selbsttests. Wärm dich auf und leg los.</p>');
      } else {
        hideResult(test);
      }
    },

    // 4.2 Ausdauer (Cooper / Step / Ruhepuls-Bonus)
    endurance: function (test) {
      var cp = qs(test, '[data-variant-panel="cooper"]');
      var sp = qs(test, '[data-variant-panel="step"]');
      var bon = qs(test, '[data-bonus]');
      if (cp) computeCooper(cp);
      if (sp) computeStep(sp);
      if (bon) computeRuhepuls(bon);
    },

    // 4.3 Kraftausdauer & Core (4 Stationen + Sit-to-Stand + Gesamt)
    strength: function (test) {
      var sex = readSex(test);
      var age = readField(test, 'age', 10, 120, true);
      var ageVal = age.valid ? age.value : NaN;
      var ratings = [];
      var items = [];

      function station(name, label, unit, evalFn) {
        var el = qs(test, '[data-in="' + name + '"]');
        var box = qs(test, '[data-st-result="' + name + '"]');
        var raw = el ? el.value : '';
        if (String(raw).trim() === '') return inlineBox(box, null);
        var n = Math.round(parseNum(raw));
        if (!isFinite(n) || n < 0) return inlineBox(box, '<span style="color:var(--ctb-red)">Bitte eine gültige Zahl eingeben.</span>');
        var res = evalFn(n);
        if (!res) return inlineBox(box, '<span>Bitte auch dein Alter oben eintragen.</span>');
        ratings.push(res.rate);
        items.push({ name: label, value: fmt(n), unit: unit, rating: res.rate, ref: res.ref || '' });
        inlineBox(box, badge(res.rate.level, res.rate.label) + (res.note ? '<span>' + esc(res.note) + '</span>' : ''));
      }

      // Station 1: Kniebeugen (ab 40 J. Schwellen je Jahrzehnt -5)
      station('squat', 'Kniebeugen (60 s)', 'Wdh.', function (n) {
        if (!isFinite(ageVal)) return null;
        var base = SQUAT[sex];
        var off = Math.max(0, Math.floor((ageVal - 30) / 10)) * 5;
        var sg = base.sg - off, gu = base.gu - off, du = base.du - off;
        return { rate: n > sg ? RATE.sehrgut : n >= gu ? RATE.gut : n >= du ? RATE.durch : RATE.ausbau,
          ref: 'in deiner Altersgruppe: durchschnittlich ab ' + du + ', gut ab ' + gu + ', sehr gut über ' + sg + ' Wdh.' };
      });

      // Station 2: Liegestütze (Variante + Altersband)
      station('push', 'Liegestütze', 'Wdh.', function (n) {
        if (!isFinite(ageVal)) return null;
        var vSeg = qs(test, '[data-in="pushvariant"]');
        var variant = vSeg ? (vSeg.getAttribute('data-value') || 'standard') : 'standard';
        var b = bandFor(PUSHUP[variant], ageVal);
        var vLabel = variant === 'knie' ? ' (auf den Knien)' : ' (Standard)';
        return { rate: n >= b.sg ? RATE.sehrgut : n >= b.gu ? RATE.gut : n >= b.du ? RATE.durch : RATE.ausbau,
          ref: 'Variante' + vLabel + ' · in deiner Altersgruppe: durchschnittlich ab ' + b.du + ', gut ab ' + b.gu + ', sehr gut ab ' + b.sg + ' Wdh.' };
      });

      // Station 3: Plank
      station('plank', 'Plank (Unterarmstütz)', 's', function (n) {
        return { rate: n > PLANK.sg ? RATE.sehrgut : n >= PLANK.gu ? RATE.gut : n >= PLANK.du ? RATE.durch : RATE.ausbau,
          ref: 'durchschnittlich ab ' + PLANK.du + ' s, gut ab ' + PLANK.gu + ' s, sehr gut über ' + PLANK.sg + ' s' };
      });

      // Station 4: Wandsitz
      station('wallsit', 'Wandsitz', 's', function (n) {
        var t = WALLSIT[sex];
        return { rate: n > t.sg ? RATE.sehrgut : n >= t.gu ? RATE.gut : n >= t.du ? RATE.durch : RATE.ausbau,
          ref: 'in deiner Gruppe: durchschnittlich ab ' + t.du + ' s, gut ab ' + t.gu + ' s, sehr gut über ' + t.sg + ' s' };
      });

      // Alternative: Sit-to-Stand (separat, zählt nicht in den 4-Stationen-Schnitt)
      (function () {
        var el = qs(test, '[data-in="s2s"]');
        var box = qs(test, '[data-st-result="s2s"]');
        var raw = el ? el.value : '';
        if (String(raw).trim() === '') return inlineBox(box, null);
        var n = Math.round(parseNum(raw));
        if (!isFinite(n) || n < 0) return inlineBox(box, '<span style="color:var(--ctb-red)">Bitte eine gültige Zahl eingeben.</span>');
        if (!isFinite(ageVal)) return inlineBox(box, '<span>Bitte auch dein Alter oben eintragen.</span>');
        var T = ageVal < 60 ? (sex === 'm' ? 17 : 15) : bandFor(SITTOSTAND, ageVal)[sex];
        var r = n >= T + 3 ? RATE.gut : n >= T ? { label: 'altersgerecht', level: 'green' } : { label: 'ausbaufähig', level: 'orange' };
        items.push({ name: 'Sit-to-Stand (30 s)', value: fmt(n), unit: 'Wdh.', rating: r, ref: 'altersgerechter Richtwert ab ' + T + ' Wdh. (zählt nicht in den Gesamtschnitt)' });
        inlineBox(box, badge(r.level, r.label) + '<span>Richtwert ab ' + T + ' Wdh.</span>');
      })();

      if (ratings.length) {
        var avg = ratings.reduce(function (a, r) { return a + r.score; }, 0) / ratings.length;
        var overall = avg >= 3.5 ? RATE.sehrgut : avg >= 2.5 ? RATE.gut : avg >= 1.5 ? RATE.durch : RATE.ausbau;
        showResult(test, badge(overall.level, 'Deine Kraftausdauer: ' + overall.label) +
          '<p class="os-ctb-result-text">Kraftausdauer – nicht Maximalkraft – ist die Basis für sicheres Board-Training.</p>' +
          coachHint(), { overall: overall, items: items });
      } else {
        hideResult(test);
      }
    },

    // 4.4 Gleichgewicht (Einbeinstand)
    balance: function (test) {
      var age = readField(test, 'age', 10, 120, true);
      var so = readField(test, 'secOpen', 0, 60, true);
      var sc = readField(test, 'secClosed', 0, 60, true);
      if (!allReady([age, so, sc])) return hideResult(test);
      var band = bandFor(BALANCE, age.value);
      function rateDur(sec, ref) {
        if (sec >= ref) return { label: 'altersgerecht bis gut', level: 'green' };
        if (sec >= 0.5 * ref) return { label: 'ausbaufähig', level: 'yellow' };
        return { label: 'Gleichgewicht gezielt trainieren', level: 'orange' };
      }
      var ro = rateDur(so.value, band.open);
      var rc = rateDur(sc.value, band.closed);
      var special = so.value >= 60 && sc.value >= 15;
      var html = (special ? badge('green', 'sehr gut – Zeit für instabile Unterlagen') : '') +
        '<div class="os-ctb-subresults">' +
        '<div class="os-ctb-subresult"><div class="lbl">Augen offen</div><div class="num">' + fmt(so.value) + ' s</div>' + badge(ro.level, ro.label) + '</div>' +
        '<div class="os-ctb-subresult"><div class="lbl">Augen geschlossen</div><div class="num">' + fmt(sc.value) + ' s</div>' + badge(rc.level, rc.label) + '</div>' +
        '</div>' +
        '<p class="os-ctb-result-text">Gleichgewicht ist trainierbar wie ein Muskel – und genau dafür ist das Sportboard gebaut. Im Coaching wählen wir die passende Progression: Boden → Halbrolle → Board.</p>' +
        coachHint();
      var lvlRank = { green: 3, yellow: 2, orange: 1, red: 0 };
      var worst = lvlRank[ro.level] <= lvlRank[rc.level] ? ro : rc;
      var overall = special ? { label: 'sehr gut', level: 'green' }
        : (ro.level === 'green' && rc.level === 'green') ? { label: 'altersgerecht bis gut', level: 'green' }
        : { label: worst.label, level: worst.level };
      showResult(test, html, {
        overall: overall,
        items: [
          { name: 'Einbeinstand – Augen offen', value: fmt(so.value), unit: 's', rating: ro, ref: 'altersgerecht ab ' + band.open + ' s' },
          { name: 'Einbeinstand – Augen geschlossen', value: fmt(sc.value), unit: 's', rating: rc, ref: 'altersgerecht ab ' + band.closed + ' s' }
        ]
      });
    },

    // 4.5 Beweglichkeit (6 Kurztests + Fazit)
    mobility: function (test) {
      var counts = { green: 0, yellow: 0, orange: 0 };
      var answered = 0;
      var items = [];
      var CHOICES = [
        { id: 'm1', name: 'Schulter / Brust', rec: 'Brustmuskulatur & Schultern mobilisieren' },
        { id: 'm2', name: 'Hüftbeuger', rec: 'Hüftbeuger verkürzt – typisch bei viel Sitzen' },
        { id: 'm3', name: 'Quadrizeps (Oberschenkel vorn)', rec: 'Oberschenkelvorderseite gezielt dehnen' },
        { id: 'm4', name: 'Hamstrings (hintere Kette)', rec: 'hintere Kette (Hamstrings) dehnen' }
      ];
      CHOICES.forEach(function (c) {
        var item = qs(test, '[data-mob="' + c.id + '"]');
        var choice = qs(item, '[data-in="choice"]');
        var box = qs(item, '[data-st-result="' + c.id + '"]');
        var val = choice.getAttribute('data-value');
        if (!val) return inlineBox(box, null);
        answered++;
        if (val === 'green') {
          counts.green++;
          items.push({ name: c.name, value: 'frei beweglich', unit: '', rating: { label: 'frei beweglich', level: 'green' }, ref: '' });
          inlineBox(box, badge('green', 'frei beweglich'));
        } else {
          counts.orange++;
          items.push({ name: c.name, value: 'eingeschränkt', unit: '', rating: { label: 'eingeschränkt', level: 'orange' }, ref: c.rec });
          inlineBox(box, badge('orange', 'eingeschränkt') + '<span>' + esc(c.rec) + '</span>');
        }
      });

      // m5 Finger-Boden-Abstand
      (function () {
        var item = qs(test, '[data-mob="m5"]');
        var palms = qs(item, '[data-in="palms"]').checked;
        var raw = qs(item, '[data-in="fba"]').value;
        var box = qs(item, '[data-st-result="m5"]');
        if (!palms && String(raw).trim() === '') return inlineBox(box, null);
        var v = palms ? -5 : parseNum(raw);
        if (!isFinite(v)) return inlineBox(box, null);
        answered++;
        var r;
        if (v <= 0) { r = { label: 'sehr gut', level: 'green', c: 'green' }; }
        else if (v <= 10) { r = { label: 'leicht eingeschränkt', level: 'yellow', c: 'yellow' }; }
        else { r = { label: 'deutlich eingeschränkt – hintere Kette dehnen', level: 'orange', c: 'orange' }; }
        counts[r.c]++;
        items.push({ name: 'Finger-Boden-Abstand', value: palms ? 'Handflächen auf dem Boden' : fmt(round(v, 1)) + ' cm', unit: '', rating: { label: r.label, level: r.level }, ref: 'sehr gut ≤ 0 cm, leicht eingeschränkt bis 10 cm' });
        inlineBox(box, badge(r.level, r.label) + '<span>' + (palms ? 'Handflächen auf' : fmt(round(v, 1)) + ' cm') + '</span>');
      })();

      // m6 Knee-to-Wall
      (function () {
        var item = qs(test, '[data-mob="m6"]');
        var lRaw = qs(item, '[data-in="kneeL"]').value, rRaw = qs(item, '[data-in="kneeR"]').value;
        var lv = parseNum(lRaw), rv = parseNum(rRaw);
        var haveL = String(lRaw).trim() !== '' && isFinite(lv);
        var haveR = String(rRaw).trim() !== '' && isFinite(rv);
        var box = qs(item, '[data-st-result="m6"]');
        if (!haveL && !haveR) return inlineBox(box, null);
        answered++;
        function rateKnee(v) {
          if (v >= 10) return { label: 'gut', level: 'green', c: 'green' };
          if (v >= 6) return { label: 'leicht eingeschränkt', level: 'yellow', c: 'yellow' };
          return { label: 'eingeschränkt – mobilisieren', level: 'orange', c: 'orange' };
        }
        var vals = [];
        if (haveL) vals.push(lv);
        if (haveR) vals.push(rv);
        var worst = Math.min.apply(null, vals);
        var r = rateKnee(worst);
        counts[r.c]++;
        var detail = (haveL ? 'L ' + fmt(round(lv, 1)) : '') + (haveL && haveR ? ' · ' : '') + (haveR ? 'R ' + fmt(round(rv, 1)) : '') + ' cm';
        var diff = (haveL && haveR && Math.abs(lv - rv) > 1.5) ? '<span>Auffällige Seitendifferenz (' + fmt(round(Math.abs(lv - rv), 1)) + ' cm)</span>' : '';
        items.push({ name: 'Knöchel (Knee-to-Wall)', value: detail, unit: '', rating: { label: r.label, level: r.level }, ref: 'gut ab 10 cm; Seitendifferenz > 1,5 cm beachten' });
        inlineBox(box, badge(r.level, r.label) + '<span>' + detail + '</span>' + diff);
      })();

      if (answered === 0) return hideResult(test);
      var free = counts.green;
      var mobLevel = free >= 4 ? 'green' : (free >= 2 ? 'yellow' : 'orange');
      showResult(test, badge(mobLevel, free + ' von 6 Bereichen frei beweglich') +
        '<div class="os-ctb-summary-counts">' +
        '<span class="os-ctb-count"><i style="background:var(--ctb-green)"></i>' + counts.green + ' frei</span>' +
        '<span class="os-ctb-count"><i style="background:var(--ctb-yellow)"></i>' + counts.yellow + ' leicht</span>' +
        '<span class="os-ctb-count"><i style="background:var(--ctb-orange)"></i>' + counts.orange + ' eingeschränkt</span>' +
        '</div>' +
        coachHint(), {
        overall: { label: free + ' von 6 Bereichen frei beweglich', level: mobLevel, tier: (free >= 4 ? 'strong' : free >= 2 ? 'onpar' : 'weak') },
        items: items
      });
    }
  };

  /* ---- Timer (Plank / Wall-Sit / Einbeinstand) ---- */
  function initTimer(t, test) {
    var display = qs(t, '[data-timer-display]');
    var toggle = qs(t, '[data-timer-toggle]');
    var reset = qs(t, '[data-timer-reset]');
    var applies = qsa(t, '[data-timer-apply]');
    var startTs = 0, acc = 0, running = false, iv = null;
    function elapsedMs() { return acc + (running ? (performance.now() - startTs) : 0); }
    function paint() { display.innerHTML = (elapsedMs() / 1000).toFixed(1).replace('.', ',') + '<span> s</span>'; }
    function start() { running = true; startTs = performance.now(); toggle.textContent = 'Stopp'; display.classList.add('is-running'); iv = setInterval(paint, 100); }
    function stop() { acc = elapsedMs(); running = false; toggle.textContent = 'Weiter'; display.classList.remove('is-running'); clearInterval(iv); paint(); }
    toggle.addEventListener('click', function () { running ? stop() : start(); });
    reset.addEventListener('click', function () { running = false; clearInterval(iv); acc = 0; toggle.textContent = 'Start'; display.classList.remove('is-running'); paint(); });
    applies.forEach(function (a) {
      var orig = a.textContent;
      var revertT = null;
      a.addEventListener('click', function () {
        var input = qs(test, '[data-in="' + a.getAttribute('data-timer-apply') + '"]');
        if (input) { input.value = String(Math.round(elapsedMs() / 1000)); input.dispatchEvent(new Event('input', { bubbles: true })); }
        // sichtbares Feedback
        a.textContent = '✓ Übernommen';
        a.classList.add('os-ctb-applied');
        if (revertT) clearTimeout(revertT);
        revertT = setTimeout(function () { a.textContent = orig; a.classList.remove('os-ctb-applied'); }, 1600);
      });
    });
  }

  /* ---- Metronom (Step-Test) via WebAudio ---- */
  function initMetro(m, test) {
    var toggle = qs(m, '[data-metro-toggle]');
    var ctx = null, iv = null, on = false;
    function beep() {
      if (!ctx) return;
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine'; o.frequency.value = 880;
      g.gain.setValueAtTime(0.0001, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.4, ctx.currentTime + 0.005);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.05);
      o.connect(g); g.connect(ctx.destination);
      o.start(); o.stop(ctx.currentTime + 0.06);
    }
    function bpm() {
      var seg = qs(test, '[data-variant-panel="step"] [data-in="sex"]') || qs(test, '[data-in="sex"]');
      var sex = seg ? (seg.getAttribute('data-value') || 'm') : 'm';
      return sex === 'm' ? 96 : 88; // 96/88 Schläge pro Minute (24/22 Vierer-Takte)
    }
    function startM() {
      ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
      if (ctx.state === 'suspended') ctx.resume();
      on = true; toggle.textContent = 'Metronom stoppen'; toggle.classList.add('os-ctb-metro-toggle-on');
      beep(); iv = setInterval(beep, 60000 / bpm());
    }
    function stopM() { on = false; toggle.textContent = 'Metronom starten'; toggle.classList.remove('os-ctb-metro-toggle-on'); clearInterval(iv); }
    toggle.addEventListener('click', function () { on ? stopM() : startM(); });
  }

  function initSelfTests(root) {
    qsa(root, '[data-test]').forEach(function (test) {
      var type = test.getAttribute('data-test');
      var compute = TEST[type];
      if (!compute) return;
      function run() { compute(test); }

      // Segment-/Auswahl-/Varianten-Umschalter mit buttons[data-val]
      qsa(test, '.os-ctb-seg, .os-ctb-choice, .os-ctb-switch[data-in]').forEach(function (seg) {
        qsa(seg, 'button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            seg.setAttribute('data-value', btn.getAttribute('data-val'));
            qsa(seg, 'button').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
            run();
          });
        });
      });

      // Eingaben live auswerten
      qsa(test, 'input, select').forEach(function (el) {
        el.addEventListener('input', run);
        el.addEventListener('change', run);
      });

      // Cooper/Step-Umschalter: Panels ein-/ausblenden
      var vSwitch = qs(test, '[data-variant-switch]');
      if (vSwitch) {
        qsa(vSwitch, 'button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var v = btn.getAttribute('data-variant');
            vSwitch.setAttribute('data-value', v);
            qsa(vSwitch, 'button').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
            qsa(test, '[data-variant-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-variant-panel') !== v; });
          });
        });
      }

      // Timer + Metronom
      qsa(test, '[data-timer]').forEach(function (t) { initTimer(t, test); });
      qsa(test, '[data-metro]').forEach(function (mm) { initMetro(mm, test); });

      run();
    });

    // "Zu den Formularen" (PAR-Q) -> Formulare-Gruppe öffnen
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-open-forms]') : null;
      if (!b) return;
      var head = root.querySelector('.os-ctb-group-head');
      if (head && head.getAttribute('aria-expanded') !== 'true') head.click();
      if (head) head.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Klickbare Info-Tooltips (Mess-Anleitungen)
  function initTooltips(root) {
    qsa(root, '[data-tip]').forEach(function (btn) {
      var box = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (box) box.hidden = open;
      });
    });
  }

  /* ==========================================================
     5) PERSISTENZ / TIMER / METRONOM — Phase 4 (folgt)
     ========================================================== */
  function initPersistence(root) {
    var KEY = 'os_coaching_tools_v1';
    var RETEST_DAYS = 49; // 7 Wochen (Spec: alle 6–8 Wochen)
    var LABELS = {
      bmi: 'BMI', waist: 'Taille & Hüfte (WHR/WHtR)', energy: 'Kalorienbedarf', hr: 'Zielherzfrequenz',
      parq: 'Vorab-Check', endurance: 'Ausdauer', strength: 'Kraftausdauer & Core', balance: 'Gleichgewicht', mobility: 'Beweglichkeit'
    };

    var exportBar = qs(root, '[data-ctb-export]');
    var statusEl = qs(root, '[data-export-status]');
    var noteEl = qs(root, '[data-export-note]');

    function inputEls() { return qsa(root, 'input[data-in], select[data-in]'); }
    function toggleEls() { return qsa(root, '[data-in]:not(input):not(select), [data-yn]'); }

    function collectState() {
      return {
        i: inputEls().map(function (el) { return el.type === 'checkbox' ? (el.checked ? 1 : 0) : el.value; }),
        t: toggleEls().map(function (el) { return el.getAttribute('data-value') || ''; })
      };
    }
    function applyState(st) {
      if (!st) return;
      var ins = inputEls();
      (st.i || []).forEach(function (v, k) {
        var el = ins[k]; if (!el) return;
        if (el.type === 'checkbox') el.checked = !!v; else el.value = v;
      });
      var tgs = toggleEls();
      (st.t || []).forEach(function (v, k) {
        var el = tgs[k]; if (!el) return;
        el.setAttribute('data-value', v);
        qsa(el, 'button').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-val') === v ? 'true' : 'false'); });
      });
    }

    function recomputeAll() {
      qsa(root, '.os-ctb-calc').forEach(function (c) { var t = c.getAttribute('data-calc'); if (CALC[t]) CALC[t](c); });
      qsa(root, '[data-test]').forEach(function (t) { var ty = t.getAttribute('data-test'); if (TEST[ty]) TEST[ty](t); });
      qsa(root, '[data-variant-switch]').forEach(function (sw) {
        var v = sw.getAttribute('data-value');
        var test = sw.closest('[data-test]');
        if (test) qsa(test, '[data-variant-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-variant-panel') !== v; });
      });
    }

    function fmtDate(d) {
      return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
    }
    var STORAGE_NOTE = 'Alles wird ausschließlich lokal auf diesem Gerät (in diesem Browser) gespeichert – es wird nichts an uns oder ins Internet übertragen. Wechselst du das Gerät oder den Browser, sind die Werte dort nicht vorhanden.';
    function setStatus(ts) {
      if (!statusEl) return;
      if (ts) {
        var last = new Date(ts);
        var due = new Date(last.getTime() + RETEST_DAYS * 86400000);
        statusEl.textContent = 'Letzter Test: ' + fmtDate(last) + ' · Re-Test fällig ab ' + fmtDate(due) + '. ' + STORAGE_NOTE;
      } else {
        statusEl.textContent = STORAGE_NOTE;
      }
    }

    // Pristine-Zustand (Markup-Defaults) fuer "Ergebnisse loeschen"
    var pristine = collectState();

    // Gespeicherten Stand laden
    var savedTs = null;
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) {
        var data = JSON.parse(raw);
        applyState(data.state);
        savedTs = data.ts || null;
        recomputeAll();
      }
    } catch (e) { /* localStorage nicht verfügbar → einfach ohne Persistenz */ }
    if (exportBar) exportBar.hidden = false;
    setStatus(savedTs);

    // Speichern (debounced)
    var saveT = null;
    function save() {
      try {
        var ts = new Date().toISOString();
        localStorage.setItem(KEY, JSON.stringify({ v: 1, ts: ts, state: collectState() }));
        savedTs = ts; setStatus(ts);
        if (noteEl) noteEl.hidden = true;
      } catch (e) { /* Speicher voll/blockiert → ignorieren */ }
    }
    function scheduleSave() { if (saveT) clearTimeout(saveT); saveT = setTimeout(save, 400); }
    root.addEventListener('input', scheduleSave, true);
    root.addEventListener('change', scheduleSave, true);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-val],[data-variant]')) scheduleSave();
    }, true);

    /* ---- Ergebnisse einsammeln ---- */
    function cleanResult(box) {
      var subs = qsa(box, '.os-ctb-subresult');
      if (subs.length) {
        return subs.map(function (s) {
          var l = qs(s, '.lbl'), n = qs(s, '.num'), b = qs(s, '.os-ctb-badge');
          return (l ? l.textContent.trim() : '') + ' ' + (n ? n.textContent.trim() : '') + ' (' + (b ? b.textContent.trim() : '') + ')';
        }).join(' · ');
      }
      var parts = [];
      var badge = qs(box, '.os-ctb-badge'); if (badge) parts.push(badge.textContent.trim());
      var val = qs(box, '.os-ctb-result-value'); if (val) parts.push(val.textContent.replace(/\s+/g, ' ').trim());
      qsa(box, '.os-ctb-metric').forEach(function (m) { parts.push(m.textContent.replace(/\s+/g, ' ').trim()); });
      qsa(box, '.os-ctb-zone').forEach(function (z) { parts.push(z.textContent.replace(/\s+/g, ' ').trim()); });
      return parts.join(' · ') || box.textContent.replace(/\s+/g, ' ').trim().slice(0, 140);
    }
    // Strukturierter Report: pro Ergebnisbox { area, overall, items[], text }
    function collectReport() {
      var out = [];
      qsa(root, '[data-result]').forEach(function (box) {
        if (box.hidden || !box.innerHTML.trim()) return;
        var host = box.closest('.os-ctb-calc, [data-test]');
        if (!host) return;
        var key = host.getAttribute('data-calc') || host.getAttribute('data-test');
        var label = LABELS[key] || 'Ergebnis';
        var vp = box.closest('[data-variant-panel]');
        if (vp) label += ' – ' + (vp.getAttribute('data-variant-panel') === 'cooper' ? 'Cooper-Test' : 'Step-Test');
        if (box.closest('[data-bonus]')) label = 'Ruhepuls';
        var rich = box.__ctb;
        var hasItems = rich && rich.items && rich.items.length;
        out.push({
          area: label,
          overall: (rich && rich.overall) ? rich.overall : null,
          items: hasItems ? rich.items : null,
          text: hasItems ? null : cleanResult(box)
        });
      });
      return out;
    }

    // Einordnung eines Gesamtergebnisses in Staerke / Mittelfeld / Fokus.
    // Primaer nach der Bedeutung des Labels (die Ampelfarbe ist je Test unterschiedlich belegt),
    // Ampelfarbe nur als Rueckfallebene.
    function tierOf(o) {
      if (o.tier) return o.tier; // expliziter Hinweis (z. B. Beweglichkeit)
      var lab = (o.label || '').toLowerCase();
      if (/schwach|ausbau|trainier|eingeschr|erh(ö|oe)ht|nicht /.test(lab)) return 'weak';
      if (/durchschnitt/.test(lab)) return 'onpar';
      if (/sehr gut|gut|altersgerecht|frei/.test(lab)) return 'strong';
      if (o.level === 'green') return 'strong';
      if (o.level === 'yellow') return 'onpar';
      return 'weak';
    }
    // Staerken / Mittelfeld / Ausbaupotenziale aus den bewerteten Bereichen
    function strengthsFor(report) {
      var strong = [], onpar = [], weak = [];
      function uniqPush(arr, name) { if (arr.indexOf(name) === -1) arr.push(name); }
      report.forEach(function (a) {
        if (!a.overall || !a.overall.label) return;
        var tier = tierOf(a.overall);
        if (tier === 'strong') uniqPush(strong, a.area);
        else if (tier === 'onpar') uniqPush(onpar, a.area);
        else uniqPush(weak, a.area);
      });
      return { strong: strong, onpar: onpar, weak: weak };
    }

    function note(msg) { if (noteEl) { noteEl.hidden = false; noteEl.textContent = msg; } }

    /* ---- CSV / Excel ---- */
    function csvCell(s) { s = String(s == null ? '' : s); return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s; }
    function exportCSV(report) {
      var lines = ['Bereich;Übung / Messwert;Dein Wert;Bewertung;Vergleich Altersgruppe'];
      report.forEach(function (a) {
        if (a.items) {
          a.items.forEach(function (it) {
            lines.push([a.area, it.name, it.value + (it.unit ? ' ' + it.unit : ''), (it.rating ? it.rating.label : ''), it.ref || ''].map(csvCell).join(';'));
          });
          if (a.overall) lines.push([a.area, 'Gesamt', '', a.overall.label, ''].map(csvCell).join(';'));
        } else {
          lines.push([a.area, '', a.text || '', (a.overall ? a.overall.label : ''), ''].map(csvCell).join(';'));
        }
      });
      var csv = '﻿' + lines.join('\r\n');
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = 'othersports-coaching-ergebnisse.csv';
      document.body.appendChild(a); a.click();
      setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
    }

    /* ---- PDF via Druckansicht ---- */
    function exportPDF(report) {
      var w = window.open('', '_blank');
      if (!w) { note('Bitte erlaube Pop-ups, damit die PDF-Ansicht geöffnet werden kann.'); return; }
      var sw = strengthsFor(report);

      // 1) Einzelergebnisse (mit Zahlen + Altersvergleich)
      var einzel = report.map(function (a) {
        var head = '<tr><th class="area" colspan="4">' + esc(a.area) +
          (a.overall ? ' <span class="b b--' + a.overall.level + '">' + esc(a.overall.label) + '</span>' : '') + '</th></tr>';
        var rows;
        if (a.items) {
          rows = a.items.map(function (it) {
            var val = esc(it.value) + (it.unit ? ' <span class="u">' + esc(it.unit) + '</span>' : '');
            var rate = it.rating ? '<span class="b b--' + it.rating.level + '">' + esc(it.rating.label) + '</span>' : '<span class="u">–</span>';
            return '<tr><td class="nm">' + esc(it.name) + '</td><td class="vl">' + val + '</td><td>' + rate + '</td><td class="rf">' + esc(it.ref || '') + '</td></tr>';
          }).join('');
        } else {
          rows = '<tr><td class="nm" colspan="4">' + esc(a.text || '') + '</td></tr>';
        }
        return head + rows;
      }).join('');

      // 2) Gesamtergebnis
      var gRows = report.filter(function (a) { return a.overall; }).map(function (a) {
        return '<tr><td>' + esc(a.area) + '</td><td><span class="b b--' + a.overall.level + '">' + esc(a.overall.label) + '</span></td></tr>';
      }).join('');
      var gesamt = gRows ? '<h2>Gesamtergebnis</h2><table class="t2"><tbody>' + gRows + '</tbody></table>' : '';

      // 3) Staerken & Ausbaupotenziale (Bezug zur Altersgruppe)
      var swParts = [];
      if (sw.strong.length) swParts.push('<p><span class="sw sw--green">Deine Stärken</span>: <b>' + esc(sw.strong.join(', ')) + '</b>.</p>');
      if (sw.onpar.length) swParts.push('<p><span class="sw sw--yellow">Im Mittelfeld</span>: <b>' + esc(sw.onpar.join(', ')) + '</b>.</p>');
      if (sw.weak.length) swParts.push('<p><span class="sw sw--orange">Hier lohnt sich der Fokus</span>: <b>' + esc(sw.weak.join(', ')) + '</b>.</p>');
      var hasMobility = report.some(function (a) { return a.area === 'Beweglichkeit'; });
      var hasFitness = report.some(function (a) { return a.overall && a.area !== 'Beweglichkeit'; });
      var closeParts = [];
      if (hasFitness) closeParts.push('Die Fitness-Tests vergleichen dich mit Richtwerten für dein Alter und Geschlecht – die genauen Vergleichswerte stehen oben je Übung.');
      if (hasMobility) closeParts.push('Die Beweglichkeits-Checks sind Ja/Nein-Einschätzungen ohne Altersnorm.');
      var swHtml = swParts.length
        ? '<h2>Stärken &amp; Ausbaupotenziale</h2>' + swParts.join('') +
          (closeParts.length ? '<p class="d">' + closeParts.join(' ') + '</p>' : '')
        : '';

      var html = '<!doctype html><html lang="de"><head><meta charset="utf-8"><title>Othersports – Coaching-Ergebnisse</title>' +
        '<style>' +
        'body{font-family:Arial,Helvetica,sans-serif;color:#232323;padding:32px;max-width:760px;margin:0 auto;line-height:1.5}' +
        'h1{font-size:22px;letter-spacing:-.02em;margin:0 0 2px}h2{font-size:15px;color:#232323;margin:26px 0 8px}' +
        '.d{color:#666;font-size:12px}' +
        'table{width:100%;border-collapse:collapse;margin-top:8px}' +
        'td,th{border-bottom:1px solid #e5e0d5;padding:8px 10px;text-align:left;font-size:12.5px;vertical-align:top}' +
        'th.area{background:#F7F5F0;color:#232323;font-size:13px;border-bottom:2px solid #C2901A;padding-top:12px}' +
        '.t1 .nm{font-weight:700;width:32%}.t1 .vl{width:16%;white-space:nowrap;font-weight:700}.t1 .rf{color:#666;font-size:11.5px;width:34%}' +
        '.u{color:#8a8578;font-weight:400}' +
        '.t2 td:first-child{font-weight:700}' +
        '.b{display:inline-block;padding:1px 8px;border-radius:999px;font-size:11px;font-weight:700;color:#fff;white-space:nowrap}' +
        '.b--green{background:#2E9E5B}.b--yellow{background:#E6A817}.b--orange{background:#E07B2E}.b--red{background:#D64545}' +
        '.sw{display:inline-block;padding:1px 8px;border-radius:999px;font-size:11.5px;font-weight:700;color:#fff}' +
        '.sw--green{background:#2E9E5B}.sw--yellow{background:#E6A817}.sw--orange{background:#E07B2E}' +
        '</style></head><body>' +
        '<h1>Coaching-Toolbox – deine Ergebnisse</h1>' +
        '<p class="d">Othersports · erstellt am ' + fmtDate(new Date()) + '</p>' +
        '<h2>Einzelergebnisse</h2>' +
        '<table class="t1"><thead><tr><th>Übung / Messwert</th><th>Dein Wert</th><th>Bewertung</th><th>Vergleich Altersgruppe</th></tr></thead><tbody>' + einzel + '</tbody></table>' +
        gesamt + swHtml +
        '<p class="d" style="margin-top:24px">Orientierungswerte – ersetzen keine ärztliche Untersuchung oder Diagnose.</p>' +
        '</body></html>';
      w.document.write(html); w.document.close(); w.focus();
      setTimeout(function () { try { w.print(); } catch (e) {} }, 350);
    }

    /* ---- Löschen ---- */
    function clearAll() {
      try { localStorage.removeItem(KEY); } catch (e) {}
      applyState(pristine);
      // Checkboxen/Choices sicher zurücksetzen
      qsa(root, 'input[type="checkbox"][data-in]').forEach(function (c) { c.checked = false; });
      recomputeAll();
      savedTs = null; setStatus(null);
      note('Ergebnisse gelöscht.');
    }

    // Werte eingetragen, aber Alter fehlt -> Bewertung (Altersgruppen-Vergleich) nicht moeglich
    function incompleteAgeTests() {
      var out = [];
      function val(scope, name) { var el = qs(scope, '[data-in="' + name + '"]'); return el ? String(el.value).trim() : ''; }
      function ageMissing(scope) { var a = qs(scope, '[data-in="age"]'); return !a || String(a.value).trim() === ''; }
      var st = qs(root, '[data-test="strength"]');
      if (st && ageMissing(st) && (val(st, 'squat') || val(st, 'push') || val(st, 's2s'))) out.push('Kraftausdauer-Test');
      var ba = qs(root, '[data-test="balance"]');
      if (ba && ageMissing(ba) && (val(ba, 'secOpen') || val(ba, 'secClosed'))) out.push('Gleichgewichts-Test');
      var cp = qs(root, '[data-variant-panel="cooper"]');
      if (cp && ageMissing(cp) && val(cp, 'dist')) out.push('Ausdauer-Test');
      return out;
    }

    // Export-Buttons
    if (exportBar) {
      exportBar.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-export]') : null;
        if (!b) return;
        var action = b.getAttribute('data-export');
        if (action === 'clear') return clearAll();
        var missing = incompleteAgeTests();
        if (missing.length) {
          note('Bitte trage im ' + missing.join(' und ') + ' oben dein Alter ein – ohne Alter lassen sich z. B. Kniebeugen und Liegestütze nicht mit deiner Altersgruppe vergleichen, und der Export bliebe unvollständig.');
          return;
        }
        var report = collectReport();
        if (!report.length) { note('Noch keine Ergebnisse – fülle zuerst einen Rechner oder Test aus.'); return; }
        if (action === 'csv') exportCSV(report);
        else if (action === 'pdf') exportPDF(report);
      });
    }
  }

  /* ==========================================================
     6) INIT PRO SECTION (idempotent, Lazy per IntersectionObserver)
     ========================================================== */
  function initRoot(root) {
    if (!root || root.dataset.ctbInit === '1') return;
    root.dataset.ctbInit = '1';

    initAccordion(root);
    qsa(root, '.os-ctb-tabgroup').forEach(initTabGroup);
    initCalculators(root);
    initTooltips(root);
    initSelfTests(root);
    initPersistence(root);
  }

  function boot() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-os-ctb]'));
    if (!roots.length) return;

    // Primaerpfad (lazy): initialisieren, sobald der Block in den Viewport scrollt.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            initRoot(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px 0px' });
      roots.forEach(function (r) { io.observe(r); });
    } else {
      roots.forEach(initRoot);
    }

    // Sofort-Init fuer bereits (nahezu) sichtbare Bloecke — unabhaengig vom IO-Timing.
    function initVisible() {
      var vh = window.innerHeight || 0;
      roots.forEach(function (r) {
        if (r.dataset.ctbInit === '1') return;
        var rect = r.getBoundingClientRect();
        if (rect.top < vh + 300 && rect.bottom > -300) initRoot(r);
      });
    }
    initVisible();

    // Sicherheitsnetz: spaetestens bei der ersten Interaktion alles initialisieren,
    // damit der Block nie "tot" wirkt, falls IO verzoegert/nicht feuert.
    var evs = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
    function onFirst() {
      roots.forEach(initRoot);
      evs.forEach(function (ev) { window.removeEventListener(ev, onFirst, true); });
    }
    evs.forEach(function (ev) { window.addEventListener(ev, onFirst, true); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
